<template>
  <vue-final-modal
      v-model="showModal"
      @click-outside="modalClose"
      classes="modal-container"
      content-class="modal-content">
    <div class="modal__tournament-result-header">
      <div class="tournament-result-title">{{ $t('QUESTION_ANSWERED') }}</div>
      <div class="answer-title">{{ convertNumberToLangWise(resultPlayed.total_correct) }} {{ $t('CORRECT_ANS') }}</div>
      <div class="answer-question">{{ $t('TOTAL_QUESTION') }} {{ convertNumberToLangWise(resultPlayed.total_quiz) }}</div>
    </div>
    <div class="modal__tournament-result-details">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <div style="color: #6BC4FF;font-size: 18px;">{{ $t('THANKS_FOR_PLAYING') }}</div>
        <div style="font-size: 14px; margin: 6px 0;">{{ $t('WILL_PUBLISH_RESULT_SOON') }} </div>
        <div class="home-btn" @click="goHomePage">{{ $t('GO_HOME') }}</div>
      </div>
      <div class="tournament-close" @click="goHomePage">X</div>
    </div>
  </vue-final-modal>
</template>

<script>
import {VueFinalModal} from 'vue-final-modal';
import {convertEnglishToMayanmar} from "@/helper/numberHelper";

export default {
  name: "TournamentResultModal",
  props: ['modalShow', 'resultPlayed'],
  components: {
    VueFinalModal,
  },
  data() {
    return {
      showModal: this.modalShow,
    }
  },
  created() {
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },
    modalClose() {
      this.emitter.emit('result-modal-close-event', {'eventContent': false});
    },
    goHomePage() {
      this.$router.push({path: '/dashboard'});
    }
  }
}
</script>

<style scoped>
:deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep .modal-content {
  display: flex;
  flex-direction: column;
  margin-left: 10%;
  margin-right: 10%;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}
@media only screen and (min-width: 1200px) {
  :deep .modal-content {

    margin-left:19%;
    margin-right:19%;


  }
}

.dark-mode div:deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
